import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CapexPlansPage } from '../../../components/capex/CapexPlansPage'

const searchSchema = z.object({
  workflow_status: z.string().optional(),
  archived: z.boolean().optional(),
})

export const Route = createFileRoute('/$org/capex-plans/')({
  validateSearch: searchSchema,
  component: CapexPlansPageRoute,
})

function CapexPlansPageRoute() {
  const { org } = Route.useParams()
  const search = Route.useSearch()
  return <CapexPlansPage org={org} workflowStatus={search.workflow_status} archived={search.archived} />
}
